import React from 'react';
import useSessionSettings from '@src/Store/selectors/useSessionSettings';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import Button from 'design-system/src/Components/Button/Button';
import CustomModal from '@src/components/general/CustomModal/CustomModal';
import Typography from 'design-system/src/Components/Typography/Typography';
import FlexBox from 'design-system/src/WebComponent/FlexBox/FlexBox.web';
import {useAppDispatch} from '@src/Store/hooks';
import appAuthSlice from '@src/Store/Slices/AppSlice/auth.slice';

interface SessionAlertProps {
  isOpen: boolean;
  onClose: () => void;
}

const SessionAlert: React.FC<SessionAlertProps> = ({isOpen, onClose}) => {
  const {alertMessage} = useSessionSettings();
  const {t} = useTranslation('session');
  const dispatch = useAppDispatch();
  const defaultMessage = t(
    'Maximum session limit reached. Please disconnect from another device.',
  );

  const message = alertMessage || defaultMessage;

  const navigateToSignup = () => {
    // Set authentication type to register
    dispatch(appAuthSlice.actions.setAuthType('register'));
    
    // Set the step to the first page
    dispatch(
      appAuthSlice.actions.setAuthStep({
        page: 'first',
        step: 0,
      }),
    );
    
    // Open the authentication modal with signup form
    dispatch(
      appAuthSlice.actions.openAuthenticationModal({
        open: true,
        redirect: '/app',
      }),
    );
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      zIndex={2000}
      closable={true}
      containerStyle={{
        maxWidth: '400px',
        width: '90%',
        height: 'auto',
      }}
      overlayStyle={{
        alignItems: 'center',
      }}
      rootStyle={{
        padding: '64px 24px 24px',
        height: 'auto',
        borderRadius: '8px',
      }}
      aria-labelledby="session-alert-modal"
      aria-describedby="session-alert-description">
      <FlexBox direction="column" gap={16} align="center">
        <FlexBox direction="column" gap={24} align="center">
          <Typography
            variant="body2"
            color="white"
            style={{
              textAlign: 'center',
            }}>
            {message}
          </Typography>

          <div
            onClick={() => {
              onClose();
              navigateToSignup();
            }}
            style={{ cursor: 'pointer' }}>
            <Typography
              variant="body2"
              color="gray"
              style={{textAlign: 'center'}}>
              {t('New user ? Create an account', {
                ns: 'session',
              })}
            </Typography>
          </div>
        </FlexBox>
        <Button
          variant="contained"
          size="small"
          onPress={onClose}
          style={{
            marginTop: '24px',
          }}
          title={t('I understand')}
        />
      </FlexBox>
    </CustomModal>
  );
};

export default SessionAlert;
